import React from 'react';

import List, {ListItem, ListItemText} from 'material-ui/List';
import Divider from 'material-ui/Divider';
import Avatar from 'material-ui/Avatar';

import CardMenu from "components/dashboard/Common/CardMenu";

import {Edit, Close, Place, Flight, Info, Timer} from 'material-ui-icons';
import Button from 'material-ui/Button';

import Grid from 'material-ui/Grid';

import BookingItem from './BookingItem';

import FlightRoute from './../../offers/routes/EditationFlightRoute';

import tsl from '../../../tsl';
import moment from 'moment-timezone';

export default class EditationAircraftInstances extends React.Component {

	state = {
    };

	componentDidMount = () => {
	}

    componentWillReceiveProps = (newProps) => {
        //console.log('flight detail', newProps.flight);
    }

	render() {
        const flight = this.props.flight;
        const {location, aircraft_model, type} = flight;
        const offer = flight.aircraft_offer.flight_offer;

        const start_time = moment(flight.start_time);
        const meeting_time = moment(flight.start_time).subtract(offer.time_before, 'minutes');
        const takeoff_time = start_time;
        const landing_time = moment(flight.start_time).add(offer.time_flight, 'minutes');
        const aircraft_free_time = moment(flight.start_time).add(offer.customer_time + offer.blocking_time_after, 'minutes');

        return (
            <Grid container spacing={8} className="w-100">

                <Grid item sm={6} xs={12}>

                    <div className="jr-card">

                        <div className={`jr-card-header-color text-center bg-primary`}>
                            <div className="jr-card-hd-content text-white">
                                <br />
                                <h2 className="text-white">{start_time.format('ddd LL')}</h2>
                            </div>
                        </div>
                        <div className="jr-card-body">

                            <div className="d-flex flex-column">
                                {
                                    offer.time_pickup !== 0 &&
                                      <div className="list-line-item">
                                        <div className="list-line-badge"/>

                                        <div className="list-line-content">
                                            <h3 className="mb-1">{tsl('flight.detail.timeline.takeoff_base')}</h3>
                                            <p className="text-muted">{moment(meeting_time).subtract(offer.time_pickup, 'minutes').format('LT')}</p>
                                        </div>
                                      </div>
                                }

                                <div className="list-line-item">
                                    <div className={`list-line-badge bg-danger`}/>

                                    <div className="list-line-content">
                                        <h3 className={`text-danger mb-1`}>{tsl('flight.detail.timeline.meeting')}</h3>
                                        <p className="text-muted">{meeting_time.format('LT')}</p>
                                    </div>
                                </div>

                                <div className="list-line-item">
                                    <div className="list-line-badge"/>

                                    <div className="list-line-content">
                                        <h3 className="mb-1">{tsl('flight.detail.timeline.takeoff')}</h3>
                                        <p className="text-muted">{takeoff_time.format('LT')}</p>
                                    </div>
                                </div>

                                <div className="list-line-item">
                                    <div className="list-line-badge bg-success"/>

                                    <div className="list-line-content">
                                        <h3 className="text-success mb-1">{offer.time_return !== 0 ? tsl('flight.detail.timeline.dropoff') : tsl('flight.detail.timeline.landing')}</h3>
                                        <p className="text-muted">{landing_time.format('LT')}</p>
                                    </div>
                                </div>

                                {
                                    (offer.time_dropoff !== 0 || offer.time_return !== 0) &&
                                      <div className="list-line-item">
                                        <div className="list-line-badge"/>

                                        <div className="list-line-content">
                                            <h3 className="mb-1">{tsl('flight.detail.timeline.takeoff')}</h3>
                                            <p className="text-muted">{moment(landing_time).add(offer.time_dropoff, 'minutes').format('LT')}</p>
                                        </div>
                                      </div>
                                }

                                {
                                    offer.time_return !== 0 &&
                                      <div className="list-line-item">
                                        <div className="list-line-badge bg-primary"/>

                                        <div className="list-line-content">
                                            <h3 className="text-primary mb-1">{tsl('flight.detail.timeline.landing_base')}</h3>
                                            <p className="text-muted">{moment(landing_time).add(offer.time_dropoff + offer.time_return, 'minutes').format('LT')}</p>
                                        </div>
                                      </div>
                                }

                                <div className="list-line-item">
                                    <div className="list-line-badge"/>

                                    <div className="list-line-content">
                                        <h3 className="mb-1">{tsl('flight.detail.timeline.aircraft_free')}</h3>
                                        <p className="text-muted">{aircraft_free_time.format('LT')}</p>
                                    </div>
                                </div>

                            </div>

                            {!this.props.onEditClick ? null : 
                                <Button color="primary" className="w-100"
                                        onClick={this.props.onEditClick}>
                                    <i className="zmdi zmdi-edit zmdi-hc-fw" />
                                    {tsl('flight.detail.change_btn')}
                                </Button>
                            }

                        </div>

                    </div>

                </Grid>


                <Grid item sm={6} xs={12}>

                    <ListItem>
                        <Avatar style={{color: 'red', backgroundColor: 'white'}}>
                           <Place /> 
                        </Avatar>
                        <ListItemText
                            primary={location.name}
                        />
                    </ListItem>
                    <ListItem divider>
                        <ListItemText secondary={location.note} />
                    </ListItem>

                    <ListItem>
                        <Avatar style={{color: 'lightblue', backgroundColor: 'white'}}>
                           <Info /> 
                        </Avatar>
                        <ListItemText
                            primary={offer.title}
                            secondary={type.title/*offer.description*/}
                        />
                    </ListItem>
                    {/*
                    <ListItem divider>
                        <ListItemText secondary={offer.description} />
                    </ListItem>
                    */}

                    <FlightRoute route={flight.route} displayed={true} editable={false} />

                    <ListItem button={this.props.onEditClick != undefined} onClick={this.props.onEditClick}>
                        <Avatar style={{color: 'orange', backgroundColor: 'white'}}>
                           <Flight /> 
                        </Avatar>
                        <ListItemText
                            primary={aircraft_model.name}
                            secondary={
                                <span>
                                    <i className="zmdi zmdi-airline-seat-recline-extra" />  
                                    {' '}
                                    {aircraft_model.passengers_capacity}
                                    <br /> 
                                    {flight.aircraft ? flight.aircraft.reg_no : ''}
                                </span>
                            }
                        />
                        {this.props.onEditClick ? <Edit /> : null}
                    </ListItem>

                </Grid>

                <Grid item sm={12} xs={12}>
                    {flight.bookings.map((booking, index) => {
                        return (<BookingItem
                                    booking={booking} key={index}
                                    nBookings={flight.bookings.length}
                                    viewOnly={(this.props.doBookingMove === undefined)}
                                    onChangeClick={this.props.doBookingMove ? this.props.doBookingMove(booking, flight) : null}
                            />);
                    })}
                </Grid>

            </Grid>
        );
    }

}


// WEBPACK FOOTER //
// ./app/used/flights/routes/Detail.js